export class MPARequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "operation",
            "baseName": "operation",
            "type": "MPAOperationType",
            "format": ""
        },
        {
            "name": "requestMethod",
            "baseName": "requestMethod",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestPath",
            "baseName": "requestPath",
            "type": "string",
            "format": ""
        },
        {
            "name": "requestBody",
            "baseName": "requestBody",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "requesterUserId",
            "baseName": "requesterUserId",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterEmail",
            "baseName": "requesterEmail",
            "type": "string",
            "format": ""
        },
        {
            "name": "requesterName",
            "baseName": "requesterName",
            "type": "string",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MPARequestStatus",
            "format": ""
        },
        {
            "name": "policyDetails",
            "baseName": "policyDetails",
            "type": "Array<MPARequestPolicyDetail>",
            "format": ""
        },
        {
            "name": "approvalExpiresAt",
            "baseName": "approvalExpiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "executionExpiresAt",
            "baseName": "executionExpiresAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resolvedAt",
            "baseName": "resolvedAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "resourceStateBefore",
            "baseName": "resourceStateBefore",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceStateAfter",
            "baseName": "resourceStateAfter",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return MPARequest.attributeTypeMap;
    }
    constructor() {
    }
}
